import React, { useState, useEffect } from 'react';

const PersonalDetails = ({
  formData,
  updateFormData,
  handleSave,
  isEditing,
}) => {
  // Initialize local state with default empty values
  const [localFormData, setLocalFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    dateOfBirth: '',
    address: '',
    ...formData, // Spread the incoming formData last to override defaults
  });

  // Update local state when props change
  useEffect(() => {
    setLocalFormData((prev) => ({
      ...prev,
      ...formData,
    }));
  }, [formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedData = {
      ...localFormData,
      [name]: value,
    };
    setLocalFormData(updatedData);
    updateFormData(updatedData);
  };

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold">Personal Details</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label
            htmlFor="firstName"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            First Name *
          </label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            value={localFormData.firstName || ''}
            onChange={handleChange}
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter first name"
          />
        </div>

        <div>
          <label
            htmlFor="lastName"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            Last Name *
          </label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            value={localFormData.lastName || ''}
            onChange={handleChange}
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter last name"
          />
        </div>

        <div>
          <label
            htmlFor="nic"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            NIC Number *
          </label>
          <input
            type="text"
            id="nic"
            name="nic"
            value={localFormData.nic}
            onChange={handleChange}
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter NIC number"
          />
        </div>

        <div>
          <label
            htmlFor="guardianName"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            Guardian Name
          </label>
          <input
            type="text"
            id="guardianName"
            name="guardianName"
            value={localFormData.guardianName}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter guardian name"
          />
        </div>

        <div>
          <label
            htmlFor="guardianContact"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            Guardian Contact Number
          </label>
          <input
            type="tel"
            id="guardianContact"
            name="guardianContact"
            value={localFormData.guardianContact}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter guardian contact number"
          />
        </div>

        <div>
          <label
            htmlFor="gender"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            Gender
          </label>
          <select
            id="gender"
            name="gender"
            value={localFormData.gender}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="male">Male</option>
            <option value="female">Female</option>
          </select>
        </div>

        <div>
          <label
            htmlFor="email"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            Email Address *
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={localFormData.email || ''}
            onChange={handleChange}
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter email address"
          />
        </div>

        <div>
          <label
            htmlFor="phone"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            Phone Number *
          </label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={localFormData.phone || ''}
            onChange={handleChange}
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter phone number"
          />
        </div>

        <div>
          <label
            htmlFor="dateOfBirth"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            Date of Birth *
          </label>
          <input
            type="date"
            id="dateOfBirth"
            name="dateOfBirth"
            value={localFormData.dateOfBirth || ''}
            onChange={handleChange}
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>

      <div>
        <label
          htmlFor="address"
          className="block text-sm font-medium text-gray-700 mb-2"
        >
          Address
        </label>
        <textarea
          id="address"
          name="address"
          value={localFormData.address || ''}
          onChange={handleChange}
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Enter address (optional)"
        />
      </div>

      {isEditing && (
        <div className="flex justify-end mt-4">
          <span onClick={handleSave} className="text-blue-600 cursor-pointer">
            Save
          </span>
        </div>
      )}
    </div>
  );
};

export default PersonalDetails;
